import styled from "styled-components";

export const CardContainer = styled.div`
  width: 100%;
  height: 50px;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  padding: 0 8px 0 8px;
  &:nth-last-child(1) {
    border-bottom: 1px solid #e8e8e8;
  }

  height: auto;
  box-sizing: border-box;
  border-top: 1px solid #e8e8e8;

  .headerSolicitacao {
    display: flex;
    justify-content: space-between;
    height: 72px;
    display: flex;
    align-items: center;

    span {
      font-size: 14px;
    }
    .containerProtocoloClassificacao {
      display: flex;
      gap: 12px;
      align-items: center;
    }

    .solicitacaocaseNumber {
      color: #003da5;
      margin-bottom: 2px;

      text-decoration: underline;

      &:hover {
        opacity: 0.8;
        cursor: pointer;
      }
    }

    .tipoSolicitacao {
      line-height: 20px;
      font-weight: bold;
      color: #4d4d4d;
    }

    .solicitacaostatus {
      border-bottom: none;
      button {
        border-radius: 4px;
        width: 100px;
        height: 32px;
        border: none;
        box-sizing: border-box;
        color: ${({ color }) => color.colorText};
        font-weight: bold;
        cursor: pointer;
        transition: 0.3s;
        background-color: ${({ color }) => color.bg};
        font-size: 12px;
        &:hover {
          box-shadow: 0px 0px 8px ${({ color }) => color.bg};
        }
      }
    }
  }
`;

export const InformationContainer = styled.div`
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;

  border-top: 1px solid #e8e8e8;
  padding-top: 12px;

  box-sizing: border-box;

  .acompanharSolicitacao {
    text-align: center;
    margin: 16px auto;
    color: #003da5;
    text-decoration: underline;
    font-size: 16px;
    margin-top: 8px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const InformationField = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 8px;
  .title {
    color: #4d4d4d;
    font-weight: bold;

    line-height: 24px;

    margin-bottom: 6px;
    font-size: 14px;
  }

  .valueContainer {
    display: flex;
    gap: 8px;

    svg {
      width: 24px;
      height: 24px;
      fill: #dc2626;
      background: #fee2e2;
      border-radius: 2px;
    }
    .value {
      color: #4d4d4d;
      width: 100%;
      padding-bottom: 4px;
      border-bottom: 2px solid #848484;
      line-height: 24px;
      font-size: 14px;
    }
  }
`;

export const ButtonExpand = styled.button`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  cursor: pointer;

  border: 1px solid #4d4d4d;
  -webkit-transform: ${({ isShowingCardInfos }) =>
    isShowingCardInfos ? "rotate(0)" : "rotate(-180deg)"};
  transform: ${({ isShowingCardInfos }) =>
    isShowingCardInfos ? "rotate(0)" : "rotate(-180deg)"};

  img {
    svg {
      fill: red !important;
    }
  }

  &:hover {
    opacity: 0.8;
  }
`;
